import { useState, useEffect, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { ESTADO_PUBLICADA } from '../../constants/publicaciones.js'
import ComponenteError from '../publicaciones/ComponenteError.jsx'
import styles from '../publicaciones/Publicaciones.module.css'
import { Filtros } from '../reutilizables/filtros/Filtros.jsx'
import * as publicacionesService from '../servicios/publicacionesService.js'
import * as tiendasOficialesService from '../servicios/tiendasOficialesService.js'
import TiendaOficial from './TiendaOficial.jsx'
import tiendaStyles from './TiendasOficiales.module.css'

const TiendasOficiales = () => {
  const [tiendas, setTiendas] = useState([])
  const [textoBusqueda, setTextoBusqueda] = useState('')
  const [publicaciones, setPublicaciones] = useState([])
  const { state } = useLocation()
  const topRef = useRef(null)
  const navigate = useNavigate()
  const idUsuario = parseInt(localStorage.getItem('idUsuario'))
  const categoriaSeleccionada = useSelector((state) => state.filters.categoriaSeleccionada)

  const { tienda, idVendedor: idVendedorState, vieneDeAdministrarTienda } = state || {}

  const buscarTiendas = useCallback(async () => {
    const { data } = await tiendasOficialesService.buscarTodas('')
    setTiendas(data.filter((t) => t.idUsuario !== idUsuario))
  }, [idUsuario])

  const buscarPublicaciones = async () => {
    const idVendedor = idVendedorState ?? 0
    const { data } = await publicacionesService.buscarTodasOptimizado(idUsuario, idVendedor, 0, '')

    const publicacionesEnTienda = data.filter(
      (p) => p.esTiendaOficial && p.idPublicacionEstado === ESTADO_PUBLICADA
    )
    setPublicaciones(publicacionesEnTienda)
  }

  useEffect(() => {
    buscarTiendas()
    buscarPublicaciones()
  }, [buscarTiendas])

  const tiendasFiltradas = tiendas.filter((t) => {
    const matchBusqueda =
      !textoBusqueda || t.nombreTienda?.toLowerCase().includes(textoBusqueda.toLowerCase())

    const matchCategoria =
      !categoriaSeleccionada ||
      publicaciones.some((p) => {
        if (p.idVendedor !== t.idUsuario) return false
        try {
          const cats = JSON.parse(p.categoriaRoot).map((c) => c.id)
          return cats.includes(Number(categoriaSeleccionada))
        } catch {
          return false
        }
      })

    return matchBusqueda && matchCategoria
  })

  return (
    <div className={styles.layout} ref={topRef}>
      {publicaciones.length > 0 && (
        <aside className={styles.filtros}>
          <Filtros
            publicaciones={publicaciones}
            buscador={{
              onChange: () => {},
              placeholder: 'Buscar tienda...',
              valor: textoBusqueda,
              setBusqueda: setTextoBusqueda
            }}
            mostrarFiltroPrecio={false}
            mostrarLimpiarFiltros={textoBusqueda}
          />
        </aside>
      )}
      <fieldset className={`fieldset ${styles.fieldset}`}>
        <div className={styles.headerPublicaciones}>
          <legend>Tiendas Oficiales</legend>
        </div>
        {vieneDeAdministrarTienda ? (
          tienda.idTiendaOficial ? (
            <div className={tiendaStyles.gridTiendas}>
              <TiendaOficial
                key={idVendedorState}
                tienda={tienda}
                onClick={() =>
                  navigate(`/Publicaciones/TiendasOficiales/${idVendedorState}`, {
                    state: { vieneConFiltroCategoria: !!categoriaSeleccionada }
                  })
                }
              />
            </div>
          ) : (
            <div className="row">
              <ComponenteError tipo="I" idAviso={25} />
            </div>
          )
        ) : tiendasFiltradas.length > 0 ? (
          <div className={tiendaStyles.gridTiendas}>
            {tiendasFiltradas.map((tienda) => (
              <TiendaOficial
                key={tienda.idUsuario}
                tienda={tienda}
                onClick={() =>
                  navigate(`/Publicaciones/TiendasOficiales/${tienda.idUsuario}`, {
                    state: { vieneConFiltroCategoria: !!categoriaSeleccionada }
                  })
                }
              />
            ))}
          </div>
        ) : (
          <div className="row">
            <ComponenteError tipo="I" idAviso={25} />
          </div>
        )}
      </fieldset>
    </div>
  )
}

export default TiendasOficiales
